/**
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * * * * * * AUTO GENERATED FILE - DO NOT EDIT ! * * * * * * *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 */
export type CookieJar = {
    [origin: string]: string[]
}
export interface CallParams {
    resource: string
    query?: Query<any, any>
    regularQueryParams?: {
        [key: string]: any
    }
    body?: any
    optionsOverrides?: Partial<RequestOptions>
}
export interface RequestParams {
    method: string
    url: string
    body?: any
    optionsOverrides?: Partial<RequestOptions>
}
import {
    AcceptNewConsoleInvitation,
    AiConversationDetail,
    AiConversationFilter,
    AiConversationSummary,
    AiDatasetStatus,
    AiInferenceLedgerEntry,
    AiModelInfo,
    AiModelPrice,
    AiModelPriceInit,
    AiProviderHealth,
    AiUsageSummary,
    Appliance,
    ApplianceDetails,
    ApplianceFilter,
    ApplianceLicenseAllocation,
    ApplianceLicenseAllocationFilter,
    ApplianceLicenseAllocationResult,
    ApplianceLicenseBundle,
    ApplianceLicenseBundleFilter,
    ApplianceLicenseBundleSyncItem,
    ApplianceLicenseBundleSyncResult,
    ApplianceLicenseInventoryFilter,
    ApplianceLicenseInventoryItem,
    ApplianceLicenseProduct,
    ApplianceLicensePurchase,
    ApplianceLicensePurchaseFilter,
    ApplianceSoftwareKeyRequest,
    ApplianceSoftwareKeyResponse,
    AuditLog,
    BatchDeleteLicenses,
    BatchReEnableLicenses,
    BatchResult,
    BatchRevokeLicenses,
    BeginLoginTotpEnrollment,
    Billing2ReportWithSummary,
    Billing2ReportedSlice,
    BillingAuditFilter,
    BillingHourlySlice,
    BillingPeriod,
    BillingReport,
    BuildInfo,
    ChangePassword,
    CompleteConsolePasswordReset,
    CompletePasskeyAuthentication,
    CompletePasskeyRegistration,
    CompleteTotpEnrollment,
    CompleteTotpLogin,
    ConsoleApplianceLicenseAllocation,
    ConsoleApplianceLicenseAllocationResult,
    ConsoleApplianceLicenseInventoryItem,
    ConsoleApplianceLicensePurchase,
    ConsoleAuditLog,
    ConsoleCustomerRtuResult,
    ConsoleInstallation,
    ConsoleInvitation,
    ConsoleInvitationAcceptance,
    ConsoleInvitationDetails,
    ConsoleInvitationRequest,
    ConsoleInvitationTokenRequest,
    ConsoleLicense,
    ConsoleLicenseKey,
    ConsoleLicenseSummary,
    ConsoleLicenseSummaryFilter,
    ConsolePasswordResetRequest,
    ConsoleProduct,
    ConsoleProductFilter,
    ConsoleUserListEntry,
    CreatedInstallation,
    CurrentExternalUser,
    CurrentUserSshPublicKey,
    Customer,
    CustomerExternalUser,
    CustomerFilter,
    CustomerRtu,
    CustomerRtuFilter,
    CustomerUpdate,
    ExternalUser,
    ExternalUserCustomerAccessUpdate,
    GlobalSettings,
    Installation,
    InstallationAiEulaAcceptances,
    InstallationFilter,
    InstallationRtu,
    InstallationRtuAllocation,
    InstallationRtuHistory,
    License,
    LicenseFilter,
    LicenseTransferRequest,
    ListAiConversationSortableField,
    ListApplianceSortableField,
    ListConsoleLicenseSummarySortableField,
    ListConsoleProductSortableField,
    ListCustomerSortableField,
    ListInstallationSortableField,
    ListLicenseSortableField,
    ListUserSortableField,
    LoginRequest,
    LoginResult,
    LogoutResponse,
    NetSuiteCustomerCandidate,
    NetSuiteCustomerImport,
    NetSuiteSyncStatus,
    NewApplianceLicenseAllocation,
    NewApplianceLicenseProduct,
    NewApplianceLicensePurchase,
    NewConsoleApplianceLicenseAllocation,
    NewCustomer,
    NewCustomerRtu,
    NewExternalUser,
    NewInstallation,
    NewLicense,
    NewUser,
    Passkey,
    PasskeyAuthenticationOptions,
    PasskeyRegistrationOptions,
    PasswordLoginResult,
    PasswordReauthentication,
    PublicLicense,
    RegisteredSshPublicKey,
    RenamePasskey,
    RtuType,
    SetSshPublicKey,
    SshCertificate,
    StaffExternalUserEntry,
    TotpEnrollment,
    TransferApplianceOwnershipRequest,
    UpdateInstallationLicenseRequest,
    UpdateInstallationLicenseResponse,
    UpdateInstallationRtu,
    UpdateLicense,
    User,
    UserFilter,
    ValidateInstallationRequest,
    ValidateInstallationResponse,
} from '../types'
import {
    AiAcceptEulaInstallationRequest,
    AiAssistantEulaAcceptance,
    AiAssistantEulaStatus,
    AiAssistantInferenceRequest,
    AiDatasetSearchRequest,
    AiDatasetSearchResult,
    AiExpertRequest,
    AiExpertResponse,
    AiInferenceResponse,
    BatchDeleteResult,
    Entity,
    ListResult,
    SortOrder,
} from 'common/api/v1/types'
import { RequestOptions, RequestResult } from 'common/network/request-options'
import { Query, toQueryParams } from 'common/query'
export abstract class BillingClient {
    protected readonly apiKey?: string
    protected readonly httpsProxy?: string
    protected readonly cookieJar: CookieJar = {}
    private readonly baseUrls: Iterator<string> & {
        length: number
        reset: () => string
    }
    private _baseUrl: string
    private _baseUrlLastSet: number
    protected constructor(params: { baseUrl: string; apiKey?: string; failbackUrls?: string[]; httpsProxy?: string }) {
        this.apiKey = params.apiKey
        this.httpsProxy = params.httpsProxy
        const baseUrlList = [...new Set([params.baseUrl, ...(params.failbackUrls ?? [])])]
        let currentUrl = 0
        this.baseUrls = {
            get length() {
                return baseUrlList.length
            },
            reset() {
                currentUrl = 0
                return baseUrlList[currentUrl]
            },
            next: () => {
                currentUrl = (currentUrl + 1) % baseUrlList.length
                return { value: baseUrlList[currentUrl], done: false }
            },
        }
        this._baseUrl = baseUrlList[0]
        this._baseUrlLastSet = Date.now()
    }
    async getGlobalsettings(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<GlobalSettings>({
            resource: `/api/globalsettings`,
            optionsOverrides,
        })
        return result.body
    }
    async setGlobalsettings(body: GlobalSettings, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<GlobalSettings>({
            resource: `/api/globalsettings`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getAiDatasets(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<AiDatasetStatus>({
            resource: `/api/ai-datasets`,
            optionsOverrides,
        })
        return result.body
    }
    async deleteGlobalsettings(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<void>({
            resource: `/api/globalsettings`,
            optionsOverrides,
        })
        return result.body
    }
    async login(body: LoginRequest, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<PasswordLoginResult>({
            resource: `/api/login/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async completeTotpLogins(body: CompleteTotpLogin, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<LoginResult>({
            resource: `/api/totp-login/complete`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async enrollmentTotpLogins(body: BeginLoginTotpEnrollment, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<TotpEnrollment>({
            resource: `/api/totp-login/enrollment`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async setTotpLoginEnrollment(body: CompleteTotpEnrollment, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<LoginResult>({
            resource: `/api/totp-login/enrollment`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteTotpLoginChallenge(challengeId: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<void>({
            resource: `/api/totp-login/challenge/${challengeId}`,
            optionsOverrides,
        })
        return result.body
    }
    async getPasskeyLoginOptions(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<PasskeyAuthenticationOptions>({
            resource: `/api/passkey-login/options`,
            optionsOverrides,
        })
        return result.body
    }
    async completePasskeyLogins(body: CompletePasskeyAuthentication, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<LoginResult>({
            resource: `/api/passkey-login/complete`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deletePasskeyLoginOptions(ceremonyId: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<void>({
            resource: `/api/passkey-login/options/${ceremonyId}`,
            optionsOverrides,
        })
        return result.body
    }
    async listCurrentUserPasskeys(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<Passkey[]>({
            resource: `/api/current-user/passkeys`,
            optionsOverrides,
        })
        return result.body
    }
    async getCurrentUserPasskeysOptions(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<PasskeyRegistrationOptions>({
            resource: `/api/current-user/passkeys/options`,
            optionsOverrides,
        })
        return result.body
    }
    async reauthenticateCurrentUsers(body: PasswordReauthentication, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<void>({
            resource: `/api/current-user/reauthenticate`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async reauthenticateCurrentUserPasskeys(
        body: PasswordReauthentication,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<void>({
            resource: `/api/current-user/passkeys/reauthenticate`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async passkeysCurrentUsers(body: CompletePasskeyRegistration, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Passkey>({
            resource: `/api/current-user/passkeys`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async setCurrentUserPasskeys(id: string, body: RenamePasskey, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._patch<Passkey>({
            resource: `/api/current-user/passkeys/${id}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteCurrentUserPasskeys(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<void>({
            resource: `/api/current-user/passkeys/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async enrollmentCurrentUserTotps(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<TotpEnrollment>({
            resource: `/api/current-user/totp/enrollment`,
            optionsOverrides,
        })
        return result.body
    }
    async setCurrentUserTotpEnrollment(body: CompleteTotpEnrollment, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<LoginResult>({
            resource: `/api/current-user/totp/enrollment`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async removeCurrentUserTotps(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<LoginResult>({
            resource: `/api/current-user/totp/remove`,
            optionsOverrides,
        })
        return result.body
    }
    async getSsoAzureLoginUrl(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<string>({
            resource: `/api/sso/azure/login-url/`,
            optionsOverrides,
        })
        return result.body
    }
    async getSsoAzureLogout(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<string>({
            resource: `/api/sso/azure/logout/`,
            optionsOverrides,
        })
        return result.body
    }
    async getAzureOauthCallbackPath(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<LoginResult>({
            resource: `/azureOauthCallbackPath`,
            optionsOverrides,
        })
        return result.body
    }
    async getCurrentUser(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<User>({
            resource: `/api/current-user`,
            optionsOverrides,
        })
        return result.body
    }
    async getCurrentUserSshKey(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<CurrentUserSshPublicKey>({
            resource: `/api/current-user/ssh-key`,
            optionsOverrides,
        })
        return result.body
    }
    async setCurrentUserSshKey(body: SetSshPublicKey, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<RegisteredSshPublicKey>({
            resource: `/api/current-user/ssh-key`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteCurrentUserSshKeys(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<void>({
            resource: `/api/current-user/ssh-key`,
            optionsOverrides,
        })
        return result.body
    }
    async logout(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<LogoutResponse>({
            resource: `/api/logout/`,
            optionsOverrides,
        })
        return result.body
    }
    async loginConsoles(body: LoginRequest, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<PasswordLoginResult>({
            resource: `/api/console/login/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async completeConsoleTotpLogins(body: CompleteTotpLogin, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<LoginResult>({
            resource: `/api/console/totp-login/complete`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async enrollmentConsoleTotpLogins(body: BeginLoginTotpEnrollment, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<TotpEnrollment>({
            resource: `/api/console/totp-login/enrollment`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async setConsoleTotpLoginEnrollment(body: CompleteTotpEnrollment, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<LoginResult>({
            resource: `/api/console/totp-login/enrollment`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteConsoleTotpLoginChallenge(challengeId: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<void>({
            resource: `/api/console/totp-login/challenge/${challengeId}`,
            optionsOverrides,
        })
        return result.body
    }
    async getConsolePasskeyLoginOptions(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<PasskeyAuthenticationOptions>({
            resource: `/api/console/passkey-login/options`,
            optionsOverrides,
        })
        return result.body
    }
    async completeConsolePasskeyLogins(
        body: CompletePasskeyAuthentication,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<LoginResult>({
            resource: `/api/console/passkey-login/complete`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteConsolePasskeyLoginOptions(ceremonyId: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<void>({
            resource: `/api/console/passkey-login/options/${ceremonyId}`,
            optionsOverrides,
        })
        return result.body
    }
    async listConsoleCurrentUserPasskeys(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<Passkey[]>({
            resource: `/api/console/current-user/passkeys`,
            optionsOverrides,
        })
        return result.body
    }
    async getConsoleCurrentUserPasskeysOptions(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<PasskeyRegistrationOptions>({
            resource: `/api/console/current-user/passkeys/options`,
            optionsOverrides,
        })
        return result.body
    }
    async reauthenticateConsoleCurrentUsers(
        body: PasswordReauthentication,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<void>({
            resource: `/api/console/current-user/reauthenticate`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async reauthenticateConsoleCurrentUserPasskeys(
        body: PasswordReauthentication,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<void>({
            resource: `/api/console/current-user/passkeys/reauthenticate`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async passkeysConsoleCurrentUsers(
        body: CompletePasskeyRegistration,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<Passkey>({
            resource: `/api/console/current-user/passkeys`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async setConsoleCurrentUserPasskeys(
        id: string,
        body: RenamePasskey,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._patch<Passkey>({
            resource: `/api/console/current-user/passkeys/${id}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteConsoleCurrentUserPasskeys(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<void>({
            resource: `/api/console/current-user/passkeys/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async enrollmentConsoleCurrentUserTotps(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<TotpEnrollment>({
            resource: `/api/console/current-user/totp/enrollment`,
            optionsOverrides,
        })
        return result.body
    }
    async setConsoleCurrentUserTotpEnrollment(
        body: CompleteTotpEnrollment,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._put<LoginResult>({
            resource: `/api/console/current-user/totp/enrollment`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async removeConsoleCurrentUserTotps(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<LoginResult>({
            resource: `/api/console/current-user/totp/remove`,
            optionsOverrides,
        })
        return result.body
    }
    async requestConsolePasswordResets(
        body: ConsolePasswordResetRequest,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<void>({
            resource: `/api/console/password-reset/request`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async completeConsolePasswordResets(
        body: CompleteConsolePasswordReset,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<void>({
            resource: `/api/console/password-reset/complete`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async inspectConsoleInvitations(
        body: ConsoleInvitationTokenRequest,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<ConsoleInvitationDetails>({
            resource: `/api/console/invitations/inspect`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async acceptConsoleInvitations(body: AcceptNewConsoleInvitation, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<ConsoleInvitationAcceptance>({
            resource: `/api/console/invitations/accept`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async acceptExistingConsoleInvitations(
        body: ConsoleInvitationTokenRequest,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<ConsoleInvitationAcceptance>({
            resource: `/api/console/invitations/accept-existing`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async logoutConsoles(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<LogoutResponse>({
            resource: `/api/console/logout/`,
            optionsOverrides,
        })
        return result.body
    }
    async getConsoleCurrentUser(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<CurrentExternalUser>({
            resource: `/api/console/current-user`,
            optionsOverrides,
        })
        return result.body
    }
    async listConsoleAuditLogs(
        query?: Query<BillingAuditFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<ConsoleAuditLog>>({
            resource: `/api/console/audit-log`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async setConsoleCurrentUserPassword(body: ChangePassword, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<void>({
            resource: `/api/console/current-user/password`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listConsoleUsers(
        query?: Query<UserFilter, SortOrder<ListUserSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<CustomerExternalUser>>({
            resource: `/api/console/users`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listConsoleUserEntries(
        query?: Query<UserFilter, SortOrder<ListUserSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<ConsoleUserListEntry>>({
            resource: `/api/console/user-entries`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getConsoleUser(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<CustomerExternalUser>({
            resource: `/api/console/users/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async requestConsoleUsersPasswordReset(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<void>({
            resource: `/api/console/users/${id}/password-reset/request`,
            optionsOverrides,
        })
        return result.body
    }
    async listConsoleInvitations(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ConsoleInvitation[]>({
            resource: `/api/console/invitations`,
            optionsOverrides,
        })
        return result.body
    }
    async invitationsConsoles(body: ConsoleInvitationRequest, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<void>({
            resource: `/api/console/invitations`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteConsoleInvitation(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<void>({
            resource: `/api/console/invitations/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async deleteConsoleUser(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<Entity>({
            resource: `/api/console/users/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async listUsers(
        query?: Query<UserFilter, SortOrder<ListUserSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<User>>({
            resource: `/api/user/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getUser(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<User>({
            resource: `/api/user/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async createUser(body: NewUser, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<User>({
            resource: `/api/user/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteUser(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<Entity>({
            resource: `/api/user/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async updateUser(id: string, body: Partial<NewUser>, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<User>({
            resource: `/api/user/${id}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteUserMfas(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<void>({
            resource: `/api/user/${id}/totp`,
            optionsOverrides,
        })
        return result.body
    }
    async createCustomer(body: NewCustomer, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Customer>({
            resource: `/api/customer/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getNetsuiteSync(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<NetSuiteSyncStatus>({
            resource: `/api/netsuite/sync/`,
            optionsOverrides,
        })
        return result.body
    }
    async listNetsuiteCustomers(
        regularQueryParams?: {
            customerNumber?: string
        },
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<NetSuiteCustomerCandidate[]>({
            resource: `/api/netsuite/customer/`,
            regularQueryParams,
            optionsOverrides,
        })
        return result.body
    }
    async importNetsuiteCustomers(body: NetSuiteCustomerImport, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Customer>({
            resource: `/api/netsuite/customer/import`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async updateCustomer(id: string, body: CustomerUpdate, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Customer>({
            resource: `/api/customer/${id}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listCustomers(
        query?: Query<CustomerFilter, SortOrder<ListCustomerSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<Customer>>({
            resource: `/api/customer/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async deleteCustomers(
        regularQueryParams?: {
            ids?: string[]
        },
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._delete<BatchDeleteResult>({
            resource: `/api/customer`,
            regularQueryParams,
            optionsOverrides,
        })
        return result.body
    }
    async listExternalUsers(
        query?: Query<UserFilter, SortOrder<ListUserSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<ExternalUser>>({
            resource: `/api/external-user/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listExternalUserEntries(
        query?: Query<UserFilter, SortOrder<ListUserSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<StaffExternalUserEntry>>({
            resource: `/api/external-user-entry/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async createExternalUser(body: NewExternalUser, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<ExternalUser>({
            resource: `/api/external-user/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getExternalUser(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ExternalUser>({
            resource: `/api/external-user/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async setExternalUserCustomerAccess(
        id: string,
        customerId: string,
        body: ExternalUserCustomerAccessUpdate,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._put<ExternalUser>({
            resource: `/api/external-user/${id}/customer-access/${customerId}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteExternalUserCustomerAccess(
        id: string,
        customerId: string,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._delete<ExternalUser>({
            resource: `/api/external-user/${id}/customer-access/${customerId}`,
            optionsOverrides,
        })
        return result.body
    }
    async requestExternalUserPasswordReset(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<void>({
            resource: `/api/external-user/${id}/password-reset/request`,
            optionsOverrides,
        })
        return result.body
    }
    async deleteExternalUserInvitation(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<void>({
            resource: `/api/external-user-invitation/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async deleteExternalUser(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<Entity>({
            resource: `/api/external-user/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async deleteExternalUserMfas(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<void>({
            resource: `/api/external-user/${id}/totp`,
            optionsOverrides,
        })
        return result.body
    }
    async listRtuTypes(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ListResult<RtuType>>({
            resource: `/api/rtu-type/`,
            optionsOverrides,
        })
        return result.body
    }
    async listCustomerRtus(
        query?: Query<CustomerRtuFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<CustomerRtu>>({
            resource: `/api/customer-rtu/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async createCustomerRtu(body: NewCustomerRtu, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<CustomerRtu>({
            resource: `/api/customer-rtu/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteCustomerRtu(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<void>({
            resource: `/api/customer-rtu/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async transferCustomerRtu(
        id: string,
        body: LicenseTransferRequest,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<CustomerRtu>({
            resource: `/api/customer-rtu/${id}/transfer`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listConsoleLicenses(
        query?: Query<ConsoleLicenseSummaryFilter, SortOrder<ListConsoleLicenseSummarySortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<ConsoleLicenseSummary>>({
            resource: `/api/console/licenses`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getConsoleLicense(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ConsoleLicense>({
            resource: `/api/console/licenses/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async getConsoleLicenseKey(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ConsoleLicenseKey>({
            resource: `/api/console/licenses/${id}/key`,
            optionsOverrides,
        })
        return result.body
    }
    async listConsoleApplianceLicenseProducts(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ListResult<ApplianceLicenseProduct>>({
            resource: `/api/console/appliance-license-products`,
            optionsOverrides,
        })
        return result.body
    }
    async listConsoleApplianceLicenseInventories(
        query?: Query<ApplianceLicenseInventoryFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<ConsoleApplianceLicenseInventoryItem>>({
            resource: `/api/console/appliance-license-inventory`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listConsoleApplianceLicensePurchases(
        query?: Query<ApplianceLicensePurchaseFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<ConsoleApplianceLicensePurchase>>({
            resource: `/api/console/appliance-license-purchases`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listConsoleApplianceLicenseAllocations(
        query?: Query<ApplianceLicenseAllocationFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<ConsoleApplianceLicenseAllocation>>({
            resource: `/api/console/appliance-license-allocations`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async applianceLicenseAllocationConsoles(
        body: NewConsoleApplianceLicenseAllocation,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<ConsoleApplianceLicenseAllocationResult>({
            resource: `/api/console/appliance-license-allocation`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listConsoleApplianceLicenseBundles(
        query?: Query<ApplianceLicenseBundleFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<ApplianceLicenseBundle>>({
            resource: `/api/console/appliance-license-bundles`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listConsoleProducts(
        query?: Query<ConsoleProductFilter, SortOrder<ListConsoleProductSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<ConsoleProduct>>({
            resource: `/api/console/products`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listConsoleInstallations(
        query?: Query<InstallationFilter, SortOrder<ListInstallationSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<ConsoleInstallation>>({
            resource: `/api/console/installations`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getConsoleInstallation(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ConsoleInstallation>({
            resource: `/api/console/installation/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async getConsoleRtuPurchases(
        query?: Query<CustomerRtuFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ConsoleCustomerRtuResult>({
            resource: `/api/console/rtu-purchases`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listConsoleInstallationRtuAllocations(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ListResult<InstallationRtuAllocation>>({
            resource: `/api/console/installation/${id}/rtu-allocations`,
            optionsOverrides,
        })
        return result.body
    }
    async setConsoleInstallationRtuAllocation(
        id: string,
        body: UpdateInstallationRtu,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._put<InstallationRtu>({
            resource: `/api/console/installation/${id}/rtu-allocation`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listConsoleInstallationRtuHistories(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ListResult<InstallationRtuHistory>>({
            resource: `/api/console/installation/${id}/rtu-history`,
            optionsOverrides,
        })
        return result.body
    }
    async createLicense(body: NewLicense, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<License>({
            resource: `/api/license/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listLicenses(
        query?: Query<LicenseFilter, SortOrder<ListLicenseSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<License>>({
            resource: `/api/license/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getLicense(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<PublicLicense>({
            resource: `/api/license/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async setLicense(id: string, body: UpdateLicense, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._patch<License>({
            resource: `/api/license/${id}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getLicenseBillingReport(
        id: string,
        regularQueryParams?: {
            startDate?: string
            endDate?: string
            format?: string
        },
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<BillingReport>({
            resource: `/api/license/${id}/billing/report`,
            regularQueryParams,
            optionsOverrides,
        })
        return result.body
    }
    async revokeLicenses(body: BatchRevokeLicenses, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<BatchResult<string>>({
            resource: `/api/license/revoke`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async reEnableLicenses(body: BatchReEnableLicenses, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<BatchResult<string>>({
            resource: `/api/license/re-enable`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteLicenses(body: BatchDeleteLicenses, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<BatchResult<string>>({
            resource: `/api/license/delete`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async createApplianceLicensePurchase(
        body: NewApplianceLicensePurchase,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<ApplianceLicensePurchase>({
            resource: `/api/appliance-license-purchase/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async transferApplianceLicensePurchase(
        id: string,
        body: LicenseTransferRequest,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<ApplianceLicensePurchase>({
            resource: `/api/appliance-license-purchase/${id}/transfer`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listApplianceLicenseProducts(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ListResult<ApplianceLicenseProduct>>({
            resource: `/api/appliance-license-product/`,
            optionsOverrides,
        })
        return result.body
    }
    async createApplianceLicenseProduct(
        body: NewApplianceLicenseProduct,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<ApplianceLicenseProduct>({
            resource: `/api/appliance-license-product/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listApplianceLicensePurchases(
        query?: Query<ApplianceLicensePurchaseFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<ApplianceLicensePurchase>>({
            resource: `/api/appliance-license-purchase/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listApplianceLicenseInventories(
        query?: Query<ApplianceLicenseInventoryFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<ApplianceLicenseInventoryItem>>({
            resource: `/api/appliance-license-inventory/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async createApplianceLicenseAllocation(
        body: NewApplianceLicenseAllocation,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<ApplianceLicenseAllocationResult>({
            resource: `/api/appliance-license-allocation/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listApplianceLicenseAllocations(
        query?: Query<ApplianceLicenseAllocationFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<ApplianceLicenseAllocation>>({
            resource: `/api/appliance-license-allocation/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listApplianceLicenseBundles(
        query?: Query<ApplianceLicenseBundleFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<ApplianceLicenseBundle>>({
            resource: `/api/appliance-license-bundle/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listAppliances(
        query?: Query<ApplianceFilter, SortOrder<ListApplianceSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<Appliance>>({
            resource: `/api/appliance/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getAppliance(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ApplianceDetails>({
            resource: `/api/appliance/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async sshCertificateAppliance(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<SshCertificate>({
            resource: `/api/appliance/${id}/ssh-certificate`,
            optionsOverrides,
        })
        return result.body
    }
    async setApplianceCustomer(
        id: string,
        body: TransferApplianceOwnershipRequest,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._patch<ApplianceDetails>({
            resource: `/api/appliance/${id}/customer`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getApplianceLicenseBundle(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ApplianceLicenseBundleSyncItem>({
            resource: `/api/appliance-license-bundle/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async createApplianceSoftwareKey(
        body: ApplianceSoftwareKeyRequest,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<ApplianceSoftwareKeyResponse>({
            resource: `/api/appliance-software-key/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async createInstallation(body: NewInstallation, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<CreatedInstallation>({
            resource: `/api/installation/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async setInstallationLicense(
        id: string,
        body: UpdateInstallationLicenseRequest,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._put<UpdateInstallationLicenseResponse>({
            resource: `/api/installation/${id}/license`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async validateInstallationUpgrade(
        id: string,
        body: ValidateInstallationRequest,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<ValidateInstallationResponse>({
            resource: `/api/installation/${id}/upgrade/validate`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async updateInstallation(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<void>({
            resource: `/api/installation/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async aiInferenceInstallation(
        id: string,
        body: AiAssistantInferenceRequest,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<AiInferenceResponse>({
            resource: `/api/installation/${id}/ai-inference`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getInstallationAiEulaUser(id: string, edgeUserId: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<AiAssistantEulaStatus>({
            resource: `/api/installation/${id}/ai-eula/user/${edgeUserId}`,
            optionsOverrides,
        })
        return result.body
    }
    async acceptanceInstallationAiEula(
        id: string,
        body: AiAcceptEulaInstallationRequest,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<AiAssistantEulaAcceptance>({
            resource: `/api/installation/${id}/ai-eula/acceptance`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getInstallationAiEulaAcceptances(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<InstallationAiEulaAcceptances>({
            resource: `/api/installation/${id}/ai-eula/acceptances`,
            optionsOverrides,
        })
        return result.body
    }
    async aiExpertInstallation(id: string, body: AiExpertRequest, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<AiExpertResponse>({
            resource: `/api/installation/${id}/ai-expert`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async aiDatasetSearchInstallation(
        id: string,
        body: AiDatasetSearchRequest,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<AiDatasetSearchResult[]>({
            resource: `/api/installation/${id}/ai-dataset-search`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async reportInstallationBilling(
        id: string,
        body: BillingHourlySlice,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<{
            lastBillingHour?: Date
        }>({
            resource: `/api/installation/${id}/billing/report`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getInstallationBillingReport(
        id: string,
        regularQueryParams?: {
            startDate?: string
            endDate?: string
            format?: string
        },
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<BillingReport>({
            resource: `/api/installation/${id}/billing/report`,
            regularQueryParams,
            optionsOverrides,
        })
        return result.body
    }
    async getInstallationBillingLastReportedHour(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<{
            startAt?: Date
        }>({
            resource: `/api/installation/${id}/billing/last-reported-hour`,
            optionsOverrides,
        })
        return result.body
    }
    async reportInstallationBilling2(
        id: string,
        body: Billing2ReportedSlice,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<{
            lastPeriod?: {
                id?: number
                startAt?: Date
            }
        }>({
            resource: `/api/installation/${id}/billing2/report`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getInstallationBilling2LastReportedPeriod(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<{
            startAt?: Date
            id?: number
        }>({
            resource: `/api/installation/${id}/billing2/last-reported-period`,
            optionsOverrides,
        })
        return result.body
    }
    async listInstallations(
        query?: Query<InstallationFilter, SortOrder<ListInstallationSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<Installation>>({
            resource: `/api/installation/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async deleteInstallation(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<void>({
            resource: `/api/installation/${id}/delete`,
            optionsOverrides,
        })
        return result.body
    }
    async restoreInstallation(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<void>({
            resource: `/api/installation/${id}/restore`,
            optionsOverrides,
        })
        return result.body
    }
    async getInstallationEntitlements(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<{
            entitlementsToken?: string
        }>({
            resource: `/api/installation/${id}/entitlements`,
            optionsOverrides,
        })
        return result.body
    }
    async getInstallationApplianceLicenseBundles(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ApplianceLicenseBundleSyncResult>({
            resource: `/api/installation/${id}/appliance-license-bundles`,
            optionsOverrides,
        })
        return result.body
    }
    async listInstallationRtuAllocations(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ListResult<InstallationRtuAllocation>>({
            resource: `/api/installation/${id}/rtu-allocation`,
            optionsOverrides,
        })
        return result.body
    }
    async setInstallationRtuAllocation(
        id: string,
        body: UpdateInstallationRtu,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._put<InstallationRtu>({
            resource: `/api/installation/${id}/rtu-allocation`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listInstallationRtuAllocationHistories(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ListResult<InstallationRtuHistory>>({
            resource: `/api/installation/${id}/rtu-allocation/history`,
            optionsOverrides,
        })
        return result.body
    }
    async listAiConversations(
        query?: Query<AiConversationFilter, SortOrder<ListAiConversationSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<AiConversationSummary>>({
            resource: `/api/ai-conversation/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getAiConversation(installationId: string, threadId: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<AiConversationDetail>({
            resource: `/api/ai-conversation/${installationId}/${threadId}`,
            optionsOverrides,
        })
        return result.body
    }
    async listAiUsages(
        regularQueryParams?: {
            customerId?: string
            startDate?: string
            endDate?: string
        },
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<AiInferenceLedgerEntry[]>({
            resource: `/api/ai-usage/`,
            regularQueryParams,
            optionsOverrides,
        })
        return result.body
    }
    async getAiUsageSummary(
        regularQueryParams?: {
            customerId?: string
            startDate?: string
            endDate?: string
        },
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<AiUsageSummary>({
            resource: `/api/ai-usage/summary`,
            regularQueryParams,
            optionsOverrides,
        })
        return result.body
    }
    async listAiPrices(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<AiModelPrice[]>({
            resource: `/api/ai-price/`,
            optionsOverrides,
        })
        return result.body
    }
    async listAiProviderHealths(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<AiProviderHealth[]>({
            resource: `/api/ai-provider/health`,
            optionsOverrides,
        })
        return result.body
    }
    async listAiModels(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<AiModelInfo[]>({
            resource: `/api/ai-model/`,
            optionsOverrides,
        })
        return result.body
    }
    async createAiPrice(body: AiModelPriceInit, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<AiModelPrice>({
            resource: `/api/ai-price/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listBillings(
        query?: Query<void, SortOrder<string>>,
        regularQueryParams?: {
            startDate?: string
            endDate?: string
            customerId?: string
            format?: string
        },
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<BillingPeriod>>({
            resource: `/api/billing`,
            query,
            regularQueryParams,
            optionsOverrides,
        })
        return result.body
    }
    async getBilling2(
        query?: Query<void, SortOrder<string>>,
        regularQueryParams?: {
            startDate?: string
            endDate?: string
            customerId?: string
            installationId?: string
            format?: string
        },
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<Billing2ReportWithSummary>({
            resource: `/api/billing2`,
            query,
            regularQueryParams,
            optionsOverrides,
        })
        return result.body
    }
    async getBilling2Period(periodId: string, optionsOverrides: Partial<RequestOptions> = { json: false }) {
        const result = await this._get<Buffer>({
            resource: `/api/billing2/period/${periodId}`,
            optionsOverrides,
        })
        return result.body
    }
    async listAuditLogs(
        query?: Query<BillingAuditFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<AuditLog>>({
            resource: `/api/audit-log/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async health(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<string>({
            resource: `/api/health`,
            optionsOverrides,
        })
        return result.body
    }
    async getBuildInfo(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<BuildInfo>({
            resource: `/api/build-info`,
            optionsOverrides,
        })
        return result.body
    }
    public get baseUrl() {
        if (Date.now() - this._baseUrlLastSet > 60000) {
            this.baseUrl = this.baseUrls.reset()
        }
        return this._baseUrl
    }
    set baseUrl(url: string) {
        this._baseUrlLastSet = Date.now()
        this._baseUrl = url
    }
    protected async _get<T>(params: CallParams) {
        return this._call<T>('GET', params)
    }
    protected async _post<T>(params: CallParams) {
        return this._call<T>('POST', params)
    }
    protected async _put<T>(params: CallParams) {
        return this._call<T>('PUT', params)
    }
    protected async _delete<T>(params: CallParams) {
        return this._call<T>('DELETE', params)
    }
    protected async _patch<T>(params: CallParams) {
        return this._call<T>('PATCH', params)
    }
    private _call<T>(method: RequestOptions['method'], params: CallParams) {
        const queryParams = Object.assign({}, params.regularQueryParams)
        if (params.query) {
            const queryObject = toQueryParams(params.query)
            Object.assign(queryParams, queryObject)
        }
        const queryString = Object.entries(queryParams)
            .reduce<string[]>((acc, [key, value]) => {
                return [
                    ...acc,
                    value === undefined || value === null
                        ? `${this.encode(key)}=`
                        : `${this.encode(key)}=${this.encode(value)}`,
                ]
            }, [])
            .join('&')
        const url = `${this.baseUrl}${params.resource}?${queryString}`
        return this.request<T>({
            method,
            url,
            body: params.body,
            optionsOverrides: params.optionsOverrides,
        })
    }
    private async request<T>(params: RequestParams, attempt = 1): Promise<RequestResult<T>> {
        try {
            return await this._request<T>(params)
        } catch (err) {
            if (this.baseUrls.length > attempt) {
                this.baseUrl = this.baseUrls.next().value
                return this.request<T>(params, attempt + 1)
            }
            throw err
        }
    }
    /// https://github.com/axios/axios/blob/master/lib/helpers/buildURL.js
    private encode(val: string | number | boolean): string {
        return encodeURIComponent(val)
            .replace(/%3A/gi, ':')
            .replace(/%24/g, '$')
            .replace(/%2C/gi, ',')
            .replace(/%20/g, '+')
            .replace(/%5B/gi, '[')
            .replace(/%5D/gi, ']')
    }
    protected abstract _request<T>(params: RequestParams): Promise<RequestResult<T>>
}
